import { Environments } from '@/config';
import { OSUWMC_PRODUCTION } from './osuwmc.production';
import { OSUWMC_STAGING } from './osuwmc.staging';

export const OSUWMC = import.meta.env.MODE === Environments.PROD ? OSUWMC_PRODUCTION : OSUWMC_STAGING;
